// ================================================================================
// wp-block-slider.js
// スライダーのスクリプトファイル
// ================================================================================

import Swiper from 'swiper';
import { EffectFade, Autoplay, Pagination } from 'swiper/modules';


window.addEventListener('load', () => {

	const el = document.querySelector('.js-slider-swiper');
	if (!el) return;

	const swiper = new Swiper(el, {
		modules: [EffectFade, Autoplay, Pagination],
		loop: true,
		slidesPerView: 1,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		speed: 1750,

		pagination: {
			el: el.querySelector('.swiper-pagination'),
			clickable: true,
		},
	});

	swiper.on('slideChangeTransitionStart', function () {
		// すべてのimgのanimationを一度リセット
		document.querySelectorAll('.slide-img img').forEach(img => {
			img.style.animation = 'none';
			// 強制リフロー（reflow）で再適用
			void img.offsetWidth;
		});

		// アクティブなスライドだけanimationを再度付与
		const activeImg = document.querySelector('.swiper-slide-active .slide-img img');
		if (activeImg) {
			activeImg.style.animation = 'slide-zoom 6s linear forwards';
		}
	});

} );
